import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'

export default {
    name: 'setting-getaway-providers-dialog-view',
    data () {
        return {
            dialog      : true,
            activeTab   : 'general',
        }
    },
    components: {
        general
    },
    watch: {
        openDialogView () {
            this.dialog = this.openDialogView
        }
    },
    computed: {
        ...mapGetters({
            currentItem     : 'settingGetawayProviders/currentItem',
            openDialogView  : 'settingGetawayProviders/openDialogView',
            basicLocales    : 'setting/basicLocales',
            editId          : 'settingGetawayProviders/editId',
            isLoading       : 'settingGetawayProviders/isLoading'
        }),
        tabs () {
            return [
                {
                    name: 'General',
                    slug: 'general',
                    id  : 1
                }
            ]
        }
    },
    created () {
        if (!this.basicLocales.length) {
            this.fetchBasicLocales()
        }
        
        if (this.editId) {
            this.fetchItem()
        }
    },
    methods: {
        ...mapActions({
            fetchItem           : 'settingGetawayProviders/GET_LIST_ITEM',
            fetchBasicLocales   : 'setting/GET_BASIC_LOCALES'
        }),
        ...mapMutations({
            changeDialogView    : 'settingGetawayProviders/CHANGE_DIALOG_VIEW',
            changeEditId        : 'settingGetawayProviders/CHANGE_EDIT_ID',
            setContent          : 'settingGetawayProviders/SET_ITEM'
        }),
        changeCloseDialog () {
            this.dialog = false
            
            this.changeDialogView(false)
            this.changeEditId('')
        },
        save(){
            this.$refs['general'].$emit('event-save');
        }
    },
    destroyed () {
        this.setContent(null)
    }
}
